import { useI18n } from "vue-i18n";

import { useMutation } from "@tanstack/vue-query";

import { useClients } from "@/hooks/clients";
import { useNotification } from "@/hooks/notifications";
import clientsApiService from "@/services/modules/clients";

import type { ReorderWhitelabelsPayload } from "@/models/clients";

export const useWhitelabelsReorderMutation = () => {
  const { showMessage } = useNotification();
  const { t } = useI18n();
  const { activeClient } = useClients();

  return useMutation({
    mutationFn: async (payload: ReorderWhitelabelsPayload) => {
      if (!activeClient.value?.id) {
        showMessage(t("ERRORS.CLIENT_ID_REQUIRED"), "error");
        return;
      }
      return clientsApiService.reorderWhitelabels(
        activeClient.value.id,
        payload
      );
    },
  });
};
